<template>
  <div class="changed__wrapper">
    <div class="changed__container">
      <div class="changed__main">
        <h3 class="changed__title">
          У Києві щодня знімають сотні рекламних роликів
        </h3>
        <p class="changed__subtitle">І ти можеш бути в одному з них!</p>
      </div>

      <div class="changed__list">
        <div class="changed__line changed__line--top" aria-hidden="true"></div>
        <div class="changed__list-content">
          <div class="changed__list-item">
            <div class="changed__list-dot"></div>
            <p class="changed__list-text">Додатковий заробіток</p>
          </div>
          <div class="changed__list-item">
            <div class="changed__list-dot"></div>
            <p class="changed__list-text">Можливість змінити професію</p>
          </div>
          <div class="changed__list-item">
            <div class="changed__list-dot"></div>
            <p class="changed__list-text">Саморозвиток і впевненість у собі</p>
          </div>
          <div class="changed__list-item">
            <div class="changed__list-dot"></div>
            <p class="changed__list-text">Нові знайомства та нетворкінг</p>
          </div>
        </div>
        <div
          class="changed__line changed__line--bottom"
          aria-hidden="true"
        ></div>
      </div>

      <!-- GALLERY -->
      <div class="changed__list-gallery">
        <img src="/static/img/changed-1.png" class="changed__list-img" />
        <img src="/static/img/changed-2.png" class="changed__list-img" />
        <img src="/static/img/changed-3.svg" class="changed__list-img" />
      </div>

      <!-- FOOTER (із лініями на всю ширину) -->
      <div class="changed__footer">
        <div class="changed__line changed__line--top" aria-hidden="true"></div>
        <p class="changed__footer-text">
          Rozetka, Monobank, Сільпо та інші шукають нові обличчя
        </p>
        <div
          class="changed__line changed__line--bottom"
          aria-hidden="true"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "changed-block",
}
</script>

<style lang="scss" scoped>
html {
  font-synthesis: none;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Light.woff2") format("woff2");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Regular.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Medium.woff2") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Bold.woff2") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

.changed {
  &__wrapper {
    max-width: 1440px;
    margin: 0 auto;
    width: 100%;
  }
  &__container {
    --x: 24px;
    padding: 160px var(--x);
  }

  &__main {
    padding-bottom: 60px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  &__title {
    font-family: "Inter", sans-serif;
    font-size: 60px;
    line-height: 60px;
    font-weight: 500;
    text-align: center;
    max-width: 735px;
    letter-spacing: -0.02em;
  }
  &__subtitle {
    font-family: "Nyght Serif";
    font-size: 60px;
    line-height: 60px;
    font-weight: 300;
    text-align: center;
    max-width: 464px;
    letter-spacing: -0.02em;
  }
  &__list {
    position: relative;
    padding: 14px 50px;
  }

  &__list-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 0 var(--x);
  }

  &__list-item {
    display: flex;
    align-items: center;
    column-gap: 12px;
  }

  &__list-text {
    font-family: "Inter", sans-serif;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    text-transform: uppercase;
    color: #000;
  }
  &__list-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #7831f3;
  }

  &__list-img {
    width: 330px;
    height: 220px;
    object-fit: cover;
  }

  &__list-gallery {
    padding: 60px 74px;
    display: flex;
    justify-content: space-between;
    column-gap: 12px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  &__list-gallery::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  &__footer {
    position: relative;
    padding: 14px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__footer-text {
    font-family: "Inter", sans-serif;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
    padding: 0 var(--x);
  }

  &__line {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    height: 1px;
    background: rgba(0, 0, 0, 0.3);
    pointer-events: none;
  }
  &__line--top {
    top: 0;
  }
  &__line--bottom {
    bottom: 0;
  }
}

@media (max-width: 1218px) {
  .changed__list-gallery {
    padding: 32px 24px;
  }
  .changed__list {
    padding: 14px 0;
  }
}
@media (max-width: 650px) {
  .changed__container {
    padding: 120px var(--x);
  }
  .changed__main {
    padding-bottom: 32px;
  }
  .changed__title,
  .changed__subtitle {
    font-size: 36px;
    line-height: 36px;
    max-width: 327px;
  }
  .changed__list-gallery {
    column-gap: 32px;
    padding: 32px 0;
  }

  .changed__line {
    width: 100%;
  }
}
</style>
